import { Sprite } from 'icons'

export const HomeIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        color='currentColor'
        fill='none'
    >
        <path
            d='M22 10.5L12.8825 2.82207C12.6355 2.61407 12.3229 2.5 12 2.5C11.6771 2.5 11.3645 2.61407 11.1175 2.82207L2 10.5'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
        <path
            d='M20.5 9.5V16C20.5 18.3456 20.5 19.5184 19.8801 20.3263C19.7205 20.5343 19.5343 20.7205 19.3263 20.8801C18.5184 21.5 17.3456 21.5 15 21.5V17C15 15.5858 15 14.8787 14.5607 14.4393C14.1213 14 13.4142 14 12 14C10.5858 14 9.87868 14 9.43934 14.4393C9 14.8787 9 15.5858 9 17V21.5C6.65442 21.5 5.48164 21.5 4.67372 20.8801C4.46572 20.7205 4.27954 20.5343 4.11994 20.3263C3.5 19.5184 3.5 18.3456 3.5 16V9.5'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
    </svg>
)

export const HomeFillIcon = (P: any) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        color='currentColor'
        class={P.classList}
    >
        <path
            d='M11.9997 1.75C12.5457 1.75 13.0743 1.94268 13.4919 2.29395L22.4753 9.85742C22.8199 10.2127 22.846 10.7785 22.5203 11.165C22.21 11.5327 21.6864 11.6121 21.2839 11.3789V15.9531C21.2839 17.0533 21.284 17.9608 21.2019 18.6885C21.127 19.3517 20.976 19.9581 20.6345 20.4961L20.4763 20.7217C20.3205 20.9245 20.145 21.1119 19.9529 21.2803L19.7537 21.4434C19.1606 21.8977 18.4771 22.0825 17.7185 22.168C16.9943 22.2495 16.0924 22.249 14.9997 22.249V17C14.9997 15.5858 14.9996 14.8788 14.5603 14.4395C14.1209 14.0002 13.4138 14 11.9997 14C10.5857 14 9.87851 14.0001 9.4392 14.4395C8.99998 14.8788 8.99975 15.5859 8.99975 17V22.249C7.90714 22.249 7.00519 22.2495 6.281 22.168C5.61706 22.0932 5.01004 21.9427 4.47143 21.6016L4.24584 21.4434C4.04268 21.2876 3.85487 21.1119 3.68627 20.9199L3.52318 20.7217C3.06823 20.1292 2.88313 19.4463 2.7976 18.6885C2.71549 17.9608 2.71555 17.0533 2.71557 15.9531V11.3789C2.31307 11.6121 1.78946 11.5327 1.47924 11.165C1.13178 10.7528 1.18491 10.1364 1.5974 9.78906L10.5085 2.29395L10.6697 2.16992C11.058 1.89775 11.5221 1.75 11.9997 1.75Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const PersonFillIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 16 16'
        height={P.size || 25}
        width={P.size || 25}
        class={P.classList}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'></path>
    </svg>
)

export const TouchIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M459.15 269.75a133.197 133.197 0 0 1-55.862 179.975l-42.782 22.541-10.52 5.533a71.277 71.277 0 0 1-62.966 1.685l-167.077-71.38 15.733-46.676 99.363 19.194-51.458-97.78-82.843-157.411 40.357-21.232 82.844 157.457 19.934-10.485-36.521-69.445 40.335-21.22 36.52 69.445 19.935-10.485-28.2-53.598 40.358-21.232 28.2 53.598 19.945-10.576-19.354-36.886 40.346-21.174 19.354 36.885 54.348 103.301zM73.268 146.674a60.03 60.03 0 0 1 42.361-102.459 60.098 60.098 0 0 1 56.58 80.169l10.588 20.013A78.29 78.29 0 0 0 115.708 26a78.233 78.233 0 0 0-5.635 156.262L99.428 162.02a59.688 59.688 0 0 1-26.16-15.346z'></path>
    </svg>
)

export const JumpingIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 15 16'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
        data-darkreader-inline-fill=''
        data-darkreader-inline-stroke=''
    >
        <path d='M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3'></path>
        <path d='m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.5 1.5 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.7.7 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.7.7 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z'></path>
    </svg>
)

export const PersonSvg = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 16 16'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z'></path>
    </svg>
)

export const MapIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='none'
        color='currentColor'
    >
        <path
            d='M22 12.0889V9.23578C22 7.29177 22 6.31978 21.4142 5.71584C20.8284 5.11192 19.8856 5.11192 18 5.11192H15.9214C15.004 5.11192 14.9964 5.11013 14.1715 4.69638L10.8399 3.0254C9.44884 2.32773 8.75332 1.97889 8.01238 2.00314C7.27143 2.02738 6.59877 2.42098 5.25345 3.20819L4.02558 3.92667C3.03739 4.5049 2.54329 4.79402 2.27164 5.27499C2 5.75596 2 6.34169 2 7.51313V15.7487C2 17.2879 2 18.0575 2.34226 18.4859C2.57001 18.7708 2.88916 18.9625 3.242 19.026C3.77226 19.1214 4.42148 18.7416 5.71987 17.9817C6.60156 17.4659 7.45011 16.9301 8.50487 17.0754C9.38869 17.1971 10.21 17.756 11 18.1522'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
        <path
            d='M8 2.00195V17.0359'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linejoin='round'
        ></path>
        <path
            d='M15 5.00879V11.0224'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
        <path
            d='M20.1069 20.1754L21.9521 21.9984M21.1691 17.6381C21.1691 19.6048 19.5752 21.1991 17.609 21.1991C15.6428 21.1991 14.0488 19.6048 14.0488 17.6381C14.0488 15.6714 15.6428 14.0771 17.609 14.0771C19.5752 14.0771 21.1691 15.6714 21.1691 17.6381Z'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
        ></path>
    </svg>
)

export const MapFillSmallIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox={'-75 0 700 512'}
        xmlns='http://www.w3.org/2000/svg'
        height={25}
        width={25}
        class={P.classList}
    >
        <path d='M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'></path>
    </svg>
)
export const MapFillIcon = (P: any) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='none'
        class={P.classList}
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M12.75 17.2765C12.75 14.7766 14.7766 12.75 17.2765 12.75C19.7765 12.75 21.8031 14.7766 21.8031 17.2765C21.8031 18.1656 21.5468 18.9947 21.104 19.6942L22.456 21.0418C22.8471 21.4317 22.8481 22.0648 22.4582 22.456C22.0683 22.8471 21.4352 22.8481 21.044 22.4582L19.6888 21.1074C18.9905 21.5481 18.1633 21.8031 17.2765 21.8031C14.7766 21.8031 12.75 19.7765 12.75 17.2765ZM17.2765 14.75C15.8812 14.75 14.75 15.8812 14.75 17.2765C14.75 18.6719 15.8812 19.8031 17.2765 19.8031C18.6719 19.8031 19.8031 18.6719 19.8031 17.2765C19.8031 15.8812 18.6719 14.75 17.2765 14.75Z'
            fill='currentColor'
        ></path>
        <path
            d='M8.75 17.1838C8.75 17.3864 8.75 17.4877 8.7977 17.5618C8.84539 17.636 8.94451 17.6811 9.14275 17.7714C9.36402 17.8723 9.6448 18.0102 10.0237 18.1986L10.6681 18.5191C11.0076 18.6879 11.1774 18.7723 11.275 18.703C11.3726 18.6337 11.3476 18.4347 11.2975 18.0367C11.2661 17.7877 11.25 17.534 11.25 17.2765C11.25 15.1336 12.3684 13.252 14.0534 12.1834C14.1515 12.1212 14.2005 12.0901 14.2252 12.0451C14.25 12.0001 14.25 11.9447 14.25 11.8339L14.25 4.07979C14.25 3.89894 14.25 3.80852 14.205 3.73592C14.16 3.66332 14.0791 3.62306 13.9171 3.54254L11.1426 2.16295C10.4736 1.8303 9.92553 1.55778 9.45232 1.3752C9.16028 1.26252 9.01425 1.20618 8.88544 1.29069L8.87522 1.2977C8.75 1.38746 8.75 1.55645 8.75 1.89444L8.75 17.1838Z'
            fill='currentColor'
        ></path>
        <path
            d='M22.75 12.9322C22.75 13.6195 22.75 13.9632 22.6218 14.0125C22.4936 14.0618 22.246 13.7876 21.7509 13.2392C20.648 12.0177 19.0519 11.25 17.2765 11.25C16.9287 11.25 16.5878 11.2795 16.2561 11.336C16.0134 11.3774 15.892 11.3981 15.821 11.3382C15.75 11.2783 15.75 11.1612 15.75 10.9272L15.75 4.33964C15.75 4.24511 15.8268 4.16857 15.9214 4.16857L18.0529 4.16857C18.9506 4.16854 19.7008 4.16851 20.2966 4.25039C20.9275 4.33708 21.4955 4.52797 21.9503 4.99278C22.4028 5.45531 22.5866 6.0292 22.6704 6.66607C22.7501 7.27181 22.75 8.03568 22.75 8.95563V12.9322Z'
            fill='currentColor'
        ></path>
        <path
            d='M7.25 1.95737C7.25 1.62984 7.25 1.46607 7.13415 1.37599C7.1208 1.36561 7.10282 1.3541 7.08779 1.34634C6.95744 1.27893 6.81999 1.34242 6.54509 1.46938C6.08426 1.68221 5.55431 1.98964 4.90724 2.36503L3.6187 3.11251C3.15062 3.38402 2.75247 3.61497 2.44084 3.84C2.10848 4.07999 1.82705 4.3455 1.61998 4.70898C1.4134 5.07159 1.32728 5.45023 1.28746 5.86053C1.24997 6.2469 1.24999 6.71323 1.25 7.26437V15.5035C1.24999 16.2326 1.24998 16.8354 1.29639 17.3069C1.34327 17.783 1.44676 18.2613 1.75833 18.6479C2.09802 19.0693 2.57688 19.3558 3.11024 19.451C3.60335 19.539 4.0707 19.3911 4.5015 19.1966C4.92742 19.0043 5.49919 18.6726 6.11822 18.3135C6.40134 18.1492 6.6546 18.0023 6.89091 17.8802C7.07195 17.7867 7.16247 17.7399 7.20624 17.668C7.25 17.5962 7.25 17.5016 7.25 17.3124L7.25 1.95737Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const DoorOpenIcon = () => (
    <svg
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={25}
        width={25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <Sprite id='navbar_door_open' />
    </svg>
)

export const DoorCloseIcon = () => (
    <svg
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={25}
        width={25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <Sprite id='navbar_door_close' />
    </svg>
)

export const WaiterIcon = () => (
    <svg
        width={25}
        height={25}
        viewBox='0 0 50 35'
        xmlns='http://www.w3.org/2000/svg'
        style={{ scale: '1.15' }}
    >
        <g id='layer1' transform='translate(-79.837175,-131.81627)'>
            <path
                style='display:inline;fill:currentColor;stroke:none'
                d='m 103.58573,131.97129 c -7.005075,1.61659 -4.298885,12.22147 2.64584,10.567 6.72397,-1.60188 4.06073,-12.1147 -2.64584,-10.567 m -19.001923,12.92984 c 0.0011,0.0191 -0.09565,-0.3828 -0.05887,-0.57037 0.08323,-0.42443 0.570486,-0.71416 0.610822,-1.1448 0.0275,-0.29355 -0.105199,-0.59586 -0.264223,-0.84414 -0.118337,-0.18475 -0.448432,-0.4648 -0.488368,-0.44129 -0.360237,0.21209 0.132354,0.83273 0.09151,1.10665 -0.03288,0.22052 -0.2318,0.46008 -0.337223,0.695 -0.09917,0.22101 -0.255533,0.43038 -0.277544,0.67161 -0.02311,0.25327 0.01944,0.53357 0.15896,0.7462 0.141644,0.21586 0.577519,0.8683 0.872203,0.65524 0.118146,-0.0854 -0.214565,-0.45821 -0.139859,-0.41441 m 18.040765,-2.1525 v 2.38125 c 1.72064,-0.69984 2.49823,-0.49468 4.23334,0 v -2.38125 c -1.627,0.53677 -2.6189,0.62778 -4.23334,0 m -9.525001,9.525 c 0,0 -5.093149,-1.68342 -6.614583,-1.5875 -1.521434,0.0959 -2.018054,0.0674 -2.192816,0.82907 -0.209152,0.91152 1.162737,1.50126 1.929253,2.03705 2.517971,1.76006 6.144252,4.1147 8.461563,3.65292 1.875118,-0.37365 3.238461,-4.35911 3.70825,-5.98987 h 0.264584 l -0.641452,8.20208 c 0,0 -0.440223,3.03311 0.357672,4.17291 0.575755,0.82247 1.409835,0.80322 2.40045,0.96646 2.69765,0.44453 5.51007,0.47726 8.20208,-2e-4 0.92223,-0.16357 1.73712,-0.20071 2.27674,-0.96626 0.69978,-0.99278 0.39175,-3.64374 0.39175,-3.64374 l -0.81641,-8.99583 h 0.26458 c 0.4679,1.62417 1.94054,5.82044 3.73173,6.32917 1.04928,0.29802 2.25384,-0.52653 3.14744,-0.97218 1.535,-0.76552 4.47716,-1.82088 5.68716,-2.81569 1.21,-0.99481 2.261,-1.48791 1.85786,-2.42219 -0.43689,-1.0125 -2.68434,-0.43725 -3.29109,-0.33612 -2.56825,0.42804 -6.10602,1.53992 -6.10602,1.53992 -0.7328,-2.54374 -2.40632,-5.76074 -4.25803,-7.66148 -0.71215,-0.73101 -1.96328,-1.84272 -3.09395,-1.42785 -1.64367,0.60309 -3.10965,5.40935 -3.76052,6.97267 h -0.52916 c -0.63606,-1.52776 -2.18025,-6.39033 -3.76072,-6.97267 -1.05933,-0.39032 -2.299544,0.59675 -3.002083,1.27555 -2.031084,1.96247 -3.537868,5.22901 -4.614286,7.81378 m -13.4298,-5.72175 v 0.26459 c 0.715894,0.57099 1.369223,1.59211 2.202616,1.95702 3.128236,1.36971 8.307655,0.33128 10.232801,-2.22161 H 79.837184 m 37.771466,-0.0991 c 2.9651,3.93196 9.02903,2.97368 12.43542,0.26459 -3.22172,-1.3519 -8.92574,-0.26459 -12.43542,-0.26459 m -18.520832,4.49792 -0.264583,0.26458 0.264583,-0.26458 m 6.085412,3.96875 c 0.31181,0.31181 0.31181,1.0111 0,1.32291 -0.12472,0.12472 -0.40444,0.12472 -0.52916,0 -0.31181,-0.31181 -0.31181,-1.0111 0,-1.32291 0.12472,-0.12472 0.40444,-0.12472 0.52916,0 z m 0.0135,-2.77049 c 0.31181,0.31182 0.31181,1.0111 0,1.32291 -0.12473,0.12473 -0.40444,0.12473 -0.52916,0 -0.31182,-0.31181 -0.31182,-1.01109 0,-1.32291 0.12472,-0.12472 0.40443,-0.12472 0.52916,0 z m -18.870382,-7.66789 c 0.0011,0.0191 -0.09566,-0.38281 -0.05887,-0.57037 0.08323,-0.42444 0.570486,-0.71416 0.610822,-1.1448 0.0275,-0.29356 -0.105199,-0.59586 -0.264223,-0.84414 -0.118336,-0.18475 -0.448432,-0.4648 -0.488368,-0.44129 -0.360237,0.21209 0.132354,0.83273 0.09151,1.10665 -0.03288,0.22052 -0.2318,0.46007 -0.337223,0.695 -0.09917,0.221 -0.255532,0.43038 -0.277544,0.67161 -0.02311,0.25327 0.01944,0.53357 0.15896,0.7462 0.141644,0.21586 0.577518,0.8683 0.872203,0.65524 0.118147,-0.0854 -0.214565,-0.45821 -0.139859,-0.41441 m 1.347436,-0.46832 c 0.0011,0.0191 -0.09566,-0.38281 -0.05887,-0.57037 0.08323,-0.42444 0.570486,-0.71416 0.610822,-1.1448 0.0275,-0.29356 -0.105199,-0.59586 -0.264223,-0.84414 -0.118336,-0.18475 -0.448432,-0.4648 -0.488368,-0.44129 -0.360237,0.21209 0.132354,0.83273 0.09151,1.10665 -0.03288,0.22052 -0.2318,0.46007 -0.337223,0.695 -0.09917,0.221 -0.255532,0.43038 -0.277544,0.67161 -0.02311,0.25327 0.01944,0.53357 0.15896,0.7462 0.141644,0.21586 0.577518,0.8683 0.872203,0.65524 0.118147,-0.0854 -0.214565,-0.45821 -0.139859,-0.41441 m 34.5799,-0.5973 c 10e-4,0.0191 -0.0957,-0.38281 -0.0589,-0.57037 0.0832,-0.42444 0.57049,-0.71416 0.61082,-1.1448 0.0275,-0.29356 -0.1052,-0.59586 -0.26422,-0.84414 -0.11834,-0.18475 -0.44843,-0.4648 -0.48837,-0.44129 -0.36024,0.21209 0.13236,0.83273 0.0915,1.10665 -0.0329,0.22052 -0.2318,0.46007 -0.33722,0.695 -0.0992,0.221 -0.25553,0.43038 -0.27755,0.67161 -0.0231,0.25327 0.0194,0.53357 0.15896,0.7462 0.14165,0.21586 0.57752,0.8683 0.87221,0.65524 0.11814,-0.0854 -0.21457,-0.45821 -0.13986,-0.41441 m 1.56513,-0.42004 c 10e-4,0.0191 -0.0957,-0.38281 -0.0589,-0.57037 0.0832,-0.42444 0.57049,-0.71416 0.61082,-1.1448 0.0275,-0.29356 -0.1052,-0.59586 -0.26422,-0.84414 -0.11834,-0.18475 -0.44843,-0.4648 -0.48837,-0.44129 -0.36023,0.21209 0.13236,0.83273 0.0915,1.10665 -0.0329,0.22052 -0.2318,0.46007 -0.33722,0.695 -0.0992,0.221 -0.25553,0.43038 -0.27754,0.67161 -0.0231,0.25327 0.0194,0.53357 0.15896,0.7462 0.14164,0.21586 0.57751,0.8683 0.8722,0.65524 0.11815,-0.0854 -0.21457,-0.45821 -0.13986,-0.41441 m 1.34744,-0.46832 c 10e-4,0.0191 -0.0957,-0.38281 -0.0589,-0.57037 0.0832,-0.42444 0.57048,-0.71416 0.61082,-1.1448 0.0275,-0.29356 -0.1052,-0.59586 -0.26423,-0.84414 -0.11833,-0.18475 -0.44843,-0.4648 -0.48836,-0.44129 -0.36024,0.21209 0.13235,0.83273 0.0915,1.10665 -0.0329,0.22052 -0.2318,0.46007 -0.33723,0.695 -0.0992,0.221 -0.25553,0.43038 -0.27754,0.67161 -0.0231,0.25327 0.0194,0.53357 0.15896,0.7462 0.14164,0.21586 0.57752,0.8683 0.8722,0.65524 0.11815,-0.0854 -0.21456,-0.45821 -0.13986,-0.41441'
                id='path1'
            />
        </g>
    </svg>
)

export const NewsIconFill = (P: any) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        color='currentColor'
        height={P.size || 25}
        width={P.size || 25}
        class={P.classList}
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M12.069 2.25C13.3923 2.24997 14.4836 2.24994 15.3472 2.36579C16.254 2.48741 17.0548 2.75258 17.696 3.39229C18.3372 4.03199 18.6029 4.83093 18.7249 5.73557C18.7803 6.14683 18.8092 6.60981 18.8244 7.125C18.8244 7.125 20.1147 7.12488 20.5796 7.18724C21.0872 7.25532 21.6079 7.4134 22.0344 7.83893C22.4609 8.26446 22.6194 8.78395 22.6876 9.29033C22.7501 9.75413 22.7501 10.3272 22.75 10.9649L22.75 18.825C22.75 20.4404 21.4374 21.75 19.8182 21.75H8.02197C6.69861 21.75 5.60737 21.7501 4.74369 21.6342C3.83695 21.5126 3.03615 21.2474 2.39495 20.6077C1.75375 19.968 1.48797 19.1691 1.36606 18.2644C1.24994 17.4028 1.24997 16.3141 1.25 14.9938V14.9938V9.00616V9.00613C1.24997 7.68589 1.24994 6.59722 1.36606 5.73557C1.48797 4.83093 1.75375 4.03199 2.39495 3.39229C3.03615 2.75258 3.83695 2.48741 4.74369 2.36579C5.60735 2.24994 6.6986 2.24997 8.02191 2.25H8.02194H12.069H12.069ZM19.8191 19.8C20.3588 19.8 20.7963 19.3634 20.7963 18.825V11.025C20.7963 10.308 20.7943 9.8683 20.7514 9.55011C20.7137 9.27043 20.6601 9.22373 20.6537 9.2182L20.6528 9.21723C20.6472 9.21089 20.6004 9.15741 20.3201 9.1198C20.0012 9.07702 19.5605 9.07495 18.8418 9.07495V18.825C18.8418 19.3634 19.2793 19.8 19.8191 19.8ZM6 7.25C5.58579 7.25 5.25 7.58579 5.25 8C5.25 8.41421 5.58579 8.75 6 8.75H14C14.4142 8.75 14.75 8.41421 14.75 8C14.75 7.58579 14.4142 7.25 14 7.25H6ZM6 11.25C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H6ZM6 15.25C5.58579 15.25 5.25 15.5858 5.25 16C5.25 16.4142 5.58579 16.75 6 16.75H10C10.4142 16.75 10.75 16.4142 10.75 16C10.75 15.5858 10.4142 15.25 10 15.25H6Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const NewsIcon = (P: any) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        color='currentColor'
        height={P.size || 25}
        width={P.size || 25}
        class={P.classList}
    >
        <path
            d='M18 15V9C18 6.17157 18 4.75736 17.1213 3.87868C16.2426 3 14.8284 3 12 3H8C5.17157 3 3.75736 3 2.87868 3.87868C2 4.75736 2 6.17157 2 9V15C2 17.8284 2 19.2426 2.87868 20.1213C3.75736 21 5.17157 21 8 21H20'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
        <path
            d='M6 8L14 8'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
        <path
            d='M6 12L14 12'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
        <path
            d='M6 16L10 16'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
        <path
            d='M18 8H19C20.4142 8 21.1213 8 21.5607 8.43934C22 8.87868 22 9.58579 22 11V19C22 20.1046 21.1046 21 20 21C18.8954 21 18 20.1046 18 19V8Z'
            stroke='currentColor'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        ></path>
    </svg>
)
